import { useEffect, useState } from "react";
import { Loader2, ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PageTitle } from "@/components/admin/AdminLayout";

const LIMIT = 50;

export default function AuditLog() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/audit", { params: { page, limit: LIMIT } }).then((r) => setData(r.data));
  }, [page]);
  const pages = data ? Math.max(1, Math.ceil(data.total / LIMIT)) : 1;
  return (
    <div data-testid="admin-audit">
      <PageTitle title="Registro attività" subtitle="Tutte le operazioni amministrative registrate dal sistema" />
      <div className="bg-white border border-slate-200 overflow-x-auto">
        {!data ? <div className="py-16 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#E50914]" /></div> : (
          <table className="w-full text-sm min-w-[640px]" data-testid="audit-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b bg-slate-50"><th className="px-4 py-3">Data</th><th>Utente</th><th>Azione</th><th>Oggetto</th><th className="pr-4">Dettagli</th></tr></thead>
            <tbody>
              {data.items.map((a) => (
                <tr key={a.id} className="border-b border-slate-100">
                  <td className="px-4 py-2.5 font-mono text-xs whitespace-nowrap">{fmtDateTime(a.created_at)}</td>
                  <td className="py-2.5">{a.user_email}</td>
                  <td className="py-2.5 font-semibold">{a.action.replace(/_/g, " ")}</td>
                  <td className="py-2.5 font-mono text-xs">{a.target}</td>
                  <td className="py-2.5 pr-4 text-slate-500">{a.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {pages > 1 && (
        <div className="mt-4 flex items-center justify-end gap-2 text-sm">
          <Button variant="outline" size="sm" className="rounded-none" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="audit-prev-btn"><ChevronLeft className="h-4 w-4" /></Button>
          <span>Pagina {page} di {pages}</span>
          <Button variant="outline" size="sm" className="rounded-none" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="audit-next-btn"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      )}
    </div>
  );
}
